<template>
  <div>
    <HelpUserTypeContrat
      v-if="displayOverlayTypeContrat && !$roles.isUtilisateurAgrial() && !$vuetify.breakpoint.mobile"
      display-value="displayAideTypeContrat"
      height="95%"
      @displayAideTypeContrat="displayAideTypeContrat"
    >
      <div slot="baseHelpMessage">
        <p>
          Filtrez ici l'affichage de vos contrats.
        </p>
      </div>
    </HelpUserTypeContrat>
    <div
      :class="$vuetify.breakpoint.mobile ? 'flex-column mb-3' : 'justify-space-between'"
      class="d-flex"
    >
      <div class="align-self-start titre-h3 mt-3 mb-3 ml-1">
        Mes contrats
        <AgrButton
          class="margin-top"
          icon
          @click="isOpenModalHelp = true"
        >
          <v-icon color="primary">
            mdi-information
          </v-icon>
        </AgrButton>
      </div>
      <AdherentRebond
        v-if="redirection"
        :class="$vuetify.breakpoint.mobile ? '' :'position'"
        :path-origine="pagePath"
        :redirection="redirection"
      />
    </div>
    <div
      v-if="isBandeauGraineAffiche"
      :class="[$vuetify.breakpoint.mobile ? 'flex-column' : 'justify-space-between', !$vuetify.breakpoint.mobile && redirection ? 'mt-2' : '']"
      class="d-flex"
    >
      <BaseSelectAnneeRecolte
        :annee-recolte-selected="anneeSelected"
        :code-graine-selected="codeGraineRs3Selected"
        :liste-annees-recoltes="listeAnneesRecoltes"
        :liste-graines-a-afficher="grainesContractualiseesEtRecoltees"
        @selectAnneeRecolte="selectRecolte"
        @selectGraine="selectGraine"
      />
      <div
        :class="$vuetify.breakpoint.mobile ? 'w-100 mt-4' : 'mr-4'"
        class="align-self-end"
      >
        <AgrButton
          v-if="hasContratsPourGraineSelectionne"
          block
          class="mb-3"
          elevation="0"
          large
          @click="onMesPrixMoyensCompares()"
        >
          <v-icon
            class="mr-4"
          >
            mdi-finance
          </v-icon>
          <span class="action white--text">Me comparer</span>
        </AgrButton>
        <BaseButton
          v-if="hasContratsPourGraineSelectionne"
          :class="$vuetify.breakpoint.mobile ? '' : 'align-self-end'"
          icon="mdi-filter-variant"
          libelle-btn="Filtrer mes contrats"
          @click="isOpenModalFiltres = true"
        />
      </div>
    </div>
    <BaseErrorMessage
      v-if="!loadingInitialisation && erreurInitialisation"
      message="Le service est momentanément indisponible"
      @reload="reloadPage"
    />
    <BaseCardV2
      v-if="!loadingInitialisation && !hasContratsPourGraineSelectionne && !erreurInitialisation"
      class="mt-5"
    >
      <div
        :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-10' "
        class="d-flex
        align-center
        flex-column pb-6"
      >
        <img
          alt="no-contrats"
          src="@/assets/no-contrats.svg"
        >
        <div
          :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
          class=" d-flex flex-column intro texte-gris-fonce  mt-2 text-justify mx-5"
        >
          <span class="text-center">Nous ne disposons pas de contrat pour cette graine et cette année de récolte.</span>
          <span class="mt-1 text-center"> Rendez-vous sur Bourse aux grains pour contractualiser votre culture avec la coopérative.</span>
          <span class="mt-1 text-center">Vous retrouverez ensuite les détails de chaque contrat (dates, poids, prix, logistique).</span>
          <span class="mt-1 mb-5 mt-5 titre-h4 secondary--text text-center">C'est un outil gratuit, accessible à tous.</span>
          <AgrButton
            color="primary darken-1"
            @click="toBag()"
          >
            <span class="action text-truncate white--text">Bourse aux grains</span>
          </AgrButton>
        </div>
      </div>
    </BaseCardV2>
    <BaseLoader v-if="loadingInitialisation" />
    <!-- Résumé de la récolte -->
    <FiltreContratChips
      v-if="!loadingInitialisation"
      :filtres="filtresContratsActifs"
      class="my-5"
      @delete="onDeleteFiltreContrat"
    />
    <ResumeDetailContrats
      v-if="!loadingInitialisation && !erreurInitialisation && hasContratsPourGraineSelectionne"
      :class="$vuetify.breakpoint.mobile ? '' : 'mr-4'"
      :graine-rs3="graineRs3Selected"
      :has-reglement-campagne="hasReglementCampagne"
      :loading-reglement-campagne="loading.reglementCampagne"
      :resumes-contrats="resumesContratsFiltres"
      :tooltip-reglement-campagne="tooltipReglementCampagne"
      class="mt-5"
      @download-reglement-campagne="telechargerPDFReglementCampagne"
    />
    <!-- liste des contrats -->
    <div
      v-if="!loadingInitialisation && hasContratsPourGraineSelectionne"
      class="mt-2"
    >
      <v-row v-if="!loading.contrats">
        <v-col
          v-for="(resumeContrat, index) in resumesContratsFiltres"
          :key="index"
          cols="12"
          md="4"
          xl="4"
        >
          <v-card class="eq-height pr-2">
            <ResumeContrat
              :resume-contrat="resumeContrat"
              @onDetailsClick="onDetailsClick"
            />
          </v-card>
        </v-col>
      </v-row>
    </div>
    <BaseCardV2
      v-if="!loadingInitialisation && hasContratsPourGraineSelectionne && !resumesContratsFiltres.length"
      class="mt-5"
    >
      <div
        :class="$vuetify.breakpoint.mobile ? 'mt-6' : 'mt-10' "
        class="d-flex
        align-center
        flex-column pb-6"
      >
        <img
          alt="no-contrats"
          src="@/assets/no-contrats.svg"
        >
        <div
          :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
          class=" d-flex flex-column intro texte-gris-fonce  mt-2 text-justify mx-5"
        >
          <span class="text-center titre-h4 secondary--text">Aucun contrat ne correspond à ces filtres.</span>
          <span class="mt-1 mb-5 mt-5 text-center">Merci de revoir vos filtres.</span>
        </div>
      </div>
    </BaseCardV2>
    <HelpModal
      v-if="isOpenModalHelp"
      titre="mes contrats"
      :is-open-modal-help="isOpenModalHelp"
      @close="isOpenModalHelp = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-8">
          <p>Vous retrouvez sur cette page les détails de chaque contrat (dates, poids, prix, lieu de livraison)</p>
          <p>Vous pouvez naviguer sur les années antérieures et/ou postérieures.</p>
          <p class="mb-0">
            Vous retrouvez vos contrats dans les rubriques suivantes :
          </p>
          <ul class="pb-4">
            <li> Prix de campagne : Prix de campagne </li>
            <li> Prix par période : Septembre-Avril, Novembre-Mai et Quinto </li>
            <li> Prix ferme : Terme moisson (dont Prix Minimum Garantis), Prix de marché (dont Prix Minimum Garantis), Tréso moisson et Matif </li>
            <li> Echange céréales semences : Echange céréales semences </li>
            <li> Echange céréales aliments : Echange céréales aliments </li>
            <li> Contrat filière : Contrat confiance et Contrat blé noir tradition Bretagne</li>
          </ul>
        </div>
      </div>
    </HelpModal>
    <DetailsContratModal
      v-if="isOpenModalDetails"
      :is-open-modal-details="isOpenModalDetails"
      :resume-contrat="resumeContratSelected"
      @close="onCloseModal"
    />
    <DetailsContratTresoMoissonAFixerModal
      v-if="isOpenModalTresoMoissonAFixerDetails"
      :is-open-modal-treso-moisson-a-fixer-details="isOpenModalTresoMoissonAFixerDetails"
      :resume-contrat="resumeContratSelected"
      @close="onCloseModal"
    />
    <ComparaisonContratsModal
      v-if="isOpenModalComparaison"
      :titre="titreFormatted(graineRs3Selected ? graineRs3Selected.libelle : null)"
      :is-open-modal-comparaison="isOpenModalComparaison"
      class="pa-3 background"
      @close="isOpenModalComparaison = false"
    />
    <InfoModal
      v-if="isOpenModaleInfosManquantes"
      confirm-text="Renseigner les infos"
      titre="Infos manquantes"
      :is-open-modale-infos-manquantes="isOpenModaleInfosManquantes"
      @close="isOpenModaleInfosManquantes = false"
      @confirm="toCompte()"
    >
      <InfoManquanteContentModal />
    </InfoModal>
    <FiltresContratModal
      v-if="isOpenModalFiltres"
      :is-open-modal-filtres="isOpenModalFiltres"
      @close="isOpenModalFiltres = false"
      @update="onUpdateFiltres"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {AgrButton} from '@agrial/ui'
import AdherentRebond from '@/views/admin/rebond/components/adherent-rebond.vue'
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseErrorMessage from '@/components/common/base-error-message.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseSelectAnneeRecolte from '@/components/common/base-select-annee-recolte.vue'
import InfoModal from '@/components/modal/info-modal.vue'
import InfoManquanteContentModal from '@/components/modal/info-manquante-content-modal.vue'
import ResumeDetailContrats from './components/resume-detail-contrats.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import HelpUserTypeContrat from './components/help-user-type-contrat.vue'
import capitalize from '@/filters/string.filter'
import ResumeContrat from '@/views/detail-contrats/components/resume-contrat.vue'
import DetailsContratModal from '@/views/detail-contrats/components/modal/details-contrat-modal.vue'
import DetailsContratTresoMoissonAFixerModal from '@/views/detail-contrats/components/modal/details-contrat-treso-moisson-a-fixer-modal.vue'
import FiltresContratModal from './components/modal/filtre-contrat-modal.vue'
import BaseButton from '@/components/common/base-button.vue'
import FiltreContratChips from '@/views/detail-contrats/components/chip/filtre-contrat-chips.vue'
import {clone} from '@/utils/clone'
import {sommeDesNombresDefinis} from '@/utils/math'
import ComparaisonContratsModal from './components/modal/comparaison-contrats-modal.vue'

export default {
  name: 'DetailContrats',
  components: {AdherentRebond, BaseButton, AgrButton, BaseCardV2, BaseSelectAnneeRecolte, ComparaisonContratsModal, ResumeContrat, HelpUserTypeContrat, HelpModal, ResumeDetailContrats, BaseLoader, BaseErrorMessage, DetailsContratModal, DetailsContratTresoMoissonAFixerModal, InfoModal, InfoManquanteContentModal, FiltresContratModal, FiltreContratChips },
  data () {
    return {
      pagePath: 'main.mes-contrats',
      loading: {
        grainesRs3: true,
        contrats: true,
        reglementCampagne: false,
        filtres: false,
        updateFiltres: false
      },
      erreur: {
        grainesRs3: false,
        contrats: false,
        reglementCampagne: false,
        filtres: false,
        updateFiltres: false
      },
      listeGrainesAAfficher: null,
      anneeSelected: null,
      codeGraineRs3Selected: null,
      resumeContratSelected: null,
      isOpenModalHelp: false,
      isOpenModalDetails: false,
      isOpenModalTresoMoissonAFixerDetails: false,
      isOpenModalComparaison: false,
      isOpenModaleInfosManquantes: false,
      isOpenModalFiltres: false,
      tooltipReglementCampagne: null,
      hasReglementCampagne: false,
      displayOverlayTypeContrat: false,
    }
  },

  computed: {
    ...mapGetters({
      adherent: 'adherent/adherent',
      anneeRecolteEnCours: 'application/anneeRecolteEnCours',
      anneeRecolteActive: 'application/anneeRecolteActive',
      codeGraineActive: 'application/codeGraineActive',
      grainesContractualiseesEtRecoltees: 'graine/grainesContractualiseesEtRecoltees',
      listeAnneesRecoltes: 'recolte/listeAnneesRecoltes',
      resumesContrats: 'contrat/resumesContrats',
      filtresContrat: 'filtresContrat/filtresAdherent',
      reglementCampagne: 'reglementCampagne/reglementCampagne',
      pdfReglementCampagne: 'reglementCampagne/pdfReglementCampagne',
      filtresAdherent: 'filtresComparaison/filtresAdherent',
      filtresValeursPossibles: 'filtresComparaison/filtresValeursPossibles',
      isParametresExploitationComplet: 'parametresExploitation/isParametresExploitationComplet',
      redirection: 'redirection/redirection'
    }),

    resumesContratsFiltres () {
      return this.resumesContrats
        .filter(contrat => this.filtresContrat.categorieContrat === 'Tous' || contrat.type.categorieContrat === this.filtresContrat.categorieContrat)
        .filter(contrat => this.filtresContrat.numeroContrat === 'Tous' || (this.filtresContrat.numeroContrat === 'Sans contrat' ? contrat.type.code === 'TRESO_MOISSON_A_FIXER' : Number(contrat.numeroContrat) === Number(this.filtresContrat.numeroContrat)))
        .filter(contrat => this.filtresContrat.etatLogistique.map(e => e.code).includes('TOUS') || this.filtresContrat.etatLogistique.map(e => e.code).includes(contrat.etatLogistique.code))
        .filter(contrat => this.filtresContrat.etatPaiement === 'Tous' || capitalize.capitalize(contrat.etatPaiement.libelle) === this.filtresContrat.etatPaiement)
        .filter(contrat => !(contrat.type.code === 'TRESO_MOISSON_A_FIXER' && this.quantiteTresoMoissonAFixer(contrat) === 0))
    },
    filtresContratsActifs () {
      let filtresChips = []
      if (this.filtresContrat.categorieContrat !== 'Tous') {
        filtresChips.push({
          type: 'categorieContrat',
          libelle: this.filtresContrat.categorieContrat
        })
      }
      if (this.filtresContrat.numeroContrat !== 'Tous') {
        filtresChips.push({
          type: 'numeroContrat',
          libelle: (this.filtresContrat.numeroContrat !== 'Sans contrat' ? 'Contrat n°' : '') + this.filtresContrat.numeroContrat
        })
      }
      if (!this.filtresContrat.etatLogistique.map(e => e.code).includes('TOUS')) {
        for (const etatLogistique of this.filtresContrat.etatLogistique) {
          filtresChips.push({
            type: 'etatLogistique',
            libelle: capitalize.capitalize(etatLogistique.libelle)
          })
        }        
      }
      if (this.filtresContrat.etatPaiement !== 'Tous') {
        filtresChips.push({
          type: 'etatPaiement',
          libelle: this.filtresContrat.etatPaiement
        })
      }

      return filtresChips
    },
    graineRs3Selected () {
      return this.grainesContractualiseesEtRecoltees.find(graine => graine.code === this.codeGraineRs3Selected)
    },
    isBandeauGraineAffiche () {
      return this.listeGrainesAAfficher && this.listeGrainesAAfficher.length
    },
    hasContratsPourGraineSelectionne () {
      return this.codeGraineRs3Selected && (this.resumesContrats.length > 0 || this.quantiteTresoMoissonEngageeAFixer > 0)
    },
    loadingInitialisation () {
      return this.loading.grainesRs3 || this.loading.contrats
    },
    erreurInitialisation () {
      return this.erreur.grainesRs3 || this.erreur.contrats
    }
  },

  created () {
    this.getRedirection(this.pagePath)
    const numtiersSelected = this.$cookies.get('NUMTIERS_SELECTED') || null
    this.getParametresExploitationComplet()
    this.fetchRecoltesContractualiseesEtRecoltees(numtiersSelected)
    this.anneeSelected = this.anneeRecolteActive != null ? this.anneeRecolteActive : this.anneeRecolteEnCours
    this.displayOverlayTypeContrat = !this.$cookies.get('DISPLAY_AIDE_TYPE_CONTRAT')
    if (numtiersSelected!= null) {
      this.fetchAdherent(numtiersSelected)
        .then(() => {
          this.loadFiltres()
          const params = {
            resumesContrats: [],
            numeroContrat: this.filtresContrat && this.filtresContrat.numeroContrat !== 'Tous' ? this.filtresContrat.numeroContrat : this.$route.params ? this.$route.params.numeroContrat : null,
            etatLogistique: this.filtresContrat && this.filtresContrat.etatLogistique && !this.filtresContrat.etatLogistique.map(e => e.code).includes('TOUS') ? this.filtresContrat.etatLogistique : null,
            categorieContrat: this.filtresContrat && this.filtresContrat.categorieContrat !== 'Tous' ? this.filtresContrat.categorieContrat : null
          }
          this.initFiltresContrats(params)
          this.loadGrainesRs3()
        })
    } else {
      this.loadFiltres()
      const params = {
        resumesContrats: [],
        numeroContrat: this.filtresContrat && this.filtresContrat.numeroContrat!= null && this.filtresContrat.numeroContrat !== 'Tous' ? this.filtresContrat.numeroContrat : this.$route.params ? this.$route.params.numeroContrat : null,
        etatLogistique: this.filtresContrat && this.filtresContrat.etatLogistique && !this.filtresContrat.etatLogistique.map(e => e.code).includes('TOUS') ? this.filtresContrat.etatLogistique : null,
        categorieContrat: this.filtresContrat && this.filtresContrat.categorieContrat !== 'Tous' ? this.filtresContrat.categorieContrat : null
      }
      this.initFiltresContrats(params)
      this.loadGrainesRs3()
    }
  },

  methods: {
    ...mapActions({
      updateAnneeRecolteActive: 'application/updateAnneeRecolteActive',
      updateCodeGraineActive: 'application/updateCodeGraineActive',
      fetchAdherent: 'adherent/fetchAdherent',
      fetchRecoltesContractualiseesEtRecoltees: 'recolte/fetchRecoltesContractualiseesEtRecoltees',
      getGrainesContractualiseesEtRecoltees: 'graine/getGrainesContractualiseesEtRecoltees',
      getReglementCampagne: 'reglementCampagne/getReglementCampagne',
      getResumesContrats: 'contrat/getResumesContrats',
      initFiltres: 'filtresComparaison/initFiltres',
      initFiltresContrats: 'filtresContrat/initFiltres',
      telechargerDocumentPdf: 'reglementCampagne/telechargerDocumentPdf',
      setFiltres: 'filtresComparaison/setFiltres',
      setFiltresContrat: 'filtresContrat/setFiltres',
      getParametresExploitationComplet: 'parametresExploitation/getParametresExploitationComplet',
      getRedirection: 'redirection/getRedirection'
    }),

    loadGrainesRs3 () {
      this.loading.grainesRs3 = true
      this.erreur.grainesRs3 = false

      this.getGrainesContractualiseesEtRecoltees(this.anneeSelected)
        .then(() => {
          if (this.grainesContractualiseesEtRecoltees.length) {
            if (this.codeGraineActive != null) {
              const indexGrainePrecedente = this.grainesContractualiseesEtRecoltees.findIndex(graine => graine.code === this.codeGraineActive)
              if (indexGrainePrecedente === -1) {
                //graine plus présente sur l'année en court
                this.codeGraineRs3Selected = this.grainesContractualiseesEtRecoltees[0].code
              } else {
                this.codeGraineRs3Selected = this.codeGraineActive
              }
            } else {
              this.codeGraineRs3Selected = this.grainesContractualiseesEtRecoltees[0].code
            }
            this.setCookieDetailContrat()
            this.loadContrats()
            this.listeGrainesAAfficher = this.grainesContractualiseesEtRecoltees
          } else {
            this.listeGrainesAAfficher = []
            this.codeGraineRs3Selected = null
            this.loading.contrats = false
          }
          this.updateCodeGraineActive(this.codeGraineRs3Selected)
        })
        .catch(() => {
          this.erreur.grainesRs3 = true
        })
        .finally(() => {
          this.loading.grainesRs3 = false
        })
    },
    setCookieDetailContrat () {
      if (this.$cookies.get('LAST_CONSULTATION_DETAIL_CONTRAT_' + this.anneeSelected + '_' + this.codeGraineRs3Selected) != null) {
        this.$cookies.remove('LAST_CONSULTATION_DETAIL_CONTRAT_' + this.anneeSelected + '_' + this.codeGraineRs3Selected)
      }
      this.$cookies.set('LAST_CONSULTATION_DETAIL_CONTRAT_' + this.anneeSelected + '_' + this.codeGraineRs3Selected, Date.now())
    },
    loadContrats () {
      this.loading.contrats = true
      this.erreur.contrats = false

      const params = {
        anneeRecolte: this.anneeSelected,
        codeGraineRs3: this.codeGraineRs3Selected,
        numeroContrat: this.filtresContrat && this.filtresContrat.numeroContrat !== 'Tous' ? this.filtresContrat.numeroContrat : null,
        etatLogistique: this.filtresContrat && this.filtresContrat.etatLogistique && !this.filtresContrat.etatLogistique.map(e => e.code).includes('TOUS') ? this.filtresContrat.etatLogistique : null,
        categorieContrat: this.filtresContrat && this.filtresContrat.categorieContrat !== 'Tous' ? this.filtresContrat.categorieContrat : null
      }
      this.getResumesContrats(params)
        .then(() => {
          if (Object.values(this.resumesContrats).length) {
            this.loadReglementCampagne()
          } else {
            this.loading.contrats = false
          }
        })
        .catch(() => {
          this.erreur.contrats = false
        })
        .finally(() => {
          this.loading.contrats = false
        })

    },
    loadReglementCampagne () {
      this.loading.reglementCampagne = true
      this.erreur.reglementCampagne = false

      this.getReglementCampagne({anneeRecolte: this.anneeSelected, codeGraineRs3: this.codeGraineRs3Selected})
        .then(() => {
          this.hasReglementCampagne = !!(this.reglementCampagne && Object.entries(this.reglementCampagne).length > 0)
          this.tooltipReglementCampagne = 'Consultation du document de règlement de campagne'
        })
        .catch(() => {
          this.tooltipReglementCampagne = 'Nous ne parvenons pas à trouver votre document de règlement de campagne.'
          this.hasReglementCampagne = false
          this.erreur.reglementCampagne = true
        })
        .finally(() => this.loading.reglementCampagne = false)
    },
    loadFiltres () {
      this.loading.filtres = true
      this.erreur.filtres = false
      return this.initFiltres(this.adherent.codeRegion)
        .catch(() => {
          this.erreur.filtres = true
        })
        .finally(() => {
          this.loading.filtres = false
        })
    },
    telechargerPDFReglementCampagne () {
      this.loading.reglementCampagne = true
      this.erreur.reglementCampagne = false

      this.telechargerDocumentPdf(this.reglementCampagne)
        .then(() => {
          setTimeout(() => {
            const popup = window.open('about:blank', '_blank')
            popup.location = window.URL.createObjectURL(new Blob([this.pdfReglementCampagne], { type: 'application/pdf' }))
          }, 100)
        })
        .catch(() => {
          this.erreur.reglementCampagne = true
          this.tooltipReglementCampagne = 'Impossible de récupérer le pdf de règlement de campagne'
          this.hasReglementCampagne = false
        })
        .finally(() => this.loading.reglementCampagne = false)
    },
    selectGraine (codeGraine) {
      this.updateCodeGraineActive(codeGraine)
      this.codeGraineRs3Selected = codeGraine
      this.setCookieDetailContrat()
      this.loadReglementCampagne()
      this.loadContrats()
      const params = {
        resumesContrats: this.resumesContrats,
        numeroContrat: null,
        etatLogistique: null,
        categorieContrat: null
      }
      this.initFiltresContrats(params)
    },
    selectRecolte (anneeRecolte) {
      this.updateAnneeRecolteActive(anneeRecolte)
      this.reloadCultures()
      this.anneeSelected = anneeRecolte
      const params = {
        resumesContrats: [],
        numeroContrat: null,
        etatLogistique: null,
        categorieContrat: null
      }
      this.initFiltresContrats(params)
      this.loadGrainesRs3()
    },
    reloadCultures () {
      this.loading.cultures = true
      this.getGrainesContractualiseesEtRecoltees(this.anneeRecolteActive)
        .then(() => {
          if (this.grainesContractualiseesEtRecoltees.filter(g => g.code === this.codeGraineActive).length === 0) {
            this.updateCodeGraineActive(this.grainesContractualiseesEtRecoltees[0].code)
          }
        })
        .finally(() => {
          this.loading.cultures = false
        })
    },
    reloadPage () {
      this.loadGrainesRs3()
    },
    onMesPrixMoyensCompares () {
      if (this.isParametresExploitationComplet) {
        this.isOpenModalComparaison = true
      } else {
        this.isOpenModaleInfosManquantes = true
      }
    },
    displayAideTypeContrat () {
      this.displayOverlayTypeContrat = false
      this.$cookies.set('DISPLAY_AIDE_TYPE_CONTRAT', 1)
    },
    quantiteTresoMoissonAFixer (contrat) {
      return Number(sommeDesNombresDefinis(
       contrat.quantiteTresoMoissonLivreeSansFixationEnKg,
        + contrat.quantiteTresoMoissonEngageAFixerEnKg,
        - contrat.quantiteTresoMoissonEnAttenteEnKg))
    },
    toBag () {
      window.open(
        window.PROPERTIES.get('URL_BOURSE_AUX_GRAINS').toString()
      )
    },
    toCompte () {
      this.isOpenModaleInfosManquantes = false
      this.$router.push({ name: 'main.compte' })
    },
    titreFormatted (texte) {
      return texte ? capitalize.capitalize(texte) : ''
    },
    onUpdateFiltres () {
      this.isOpenModalFiltres = false
    },
    onDeleteFiltreContrat (filtreASupprimer) {
      const filtresContrat = clone(this.filtresContrat)
      if (filtreASupprimer.length && filtreASupprimer[0].type === 'etatLogistique') {
        filtresContrat[filtreASupprimer[0].type] = [{code: 'TOUS', libelle: 'Tous'}]
      } else {
      filtresContrat[filtreASupprimer[0].type] = 'Tous'
      }
      this.setFiltresContrat(filtresContrat)
    },
    onDetailsClick (resumeContrat) {
      this.resumeContratSelected = resumeContrat
        if (resumeContrat.type.code === 'TRESO_MOISSON_A_FIXER') {
          this.isOpenModalTresoMoissonAFixerDetails = true
        } else {
          this.isOpenModalDetails = true
        }
    },
    onCloseModal () {
      this.isOpenModalDetails = false
      this.isOpenModalTresoMoissonAFixerDetails = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .background {
    background: var(--gris);
  }
  hr.not-full {
    margin: 8px 0;
  }
  .position {
    position: absolute;
    top: 0;
    right: 20px;
  }
</style>
